import { StyleSheet } from 'react-native'
import { color, fontFamily } from '../../../../../../theme'

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: color.palette.lightGrey,
    borderRadius: 4,
    marginTop: 4
  },
  user: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '75%'
  },
  text: {
    textAlign: 'center',
    fontFamily: fontFamily.GTAmericaExtended,
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 19.2
  }
})
